import "core-js/modules/es6.regexp.search";
import _objectSpread from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { previewDataInterface } from '@/api/systemData/dataInterface'
import request from "@/utils/request";
export default {
  name: "suppliers",
  props: {
    value: {
      default: ""
    },
    interfaceId: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: "请选择"
    },
    // 请求接口方式默认POST
    strmethod: {
      type: String,
      default: "POST"
    },
    propsValue: {
      type: String,
      default: ""
    },
    columnOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    appendtobody: {
      type: Boolean,
      default: true
    },
    // 搜索条件
    SearchKey: {
      type: String,
      default: ""
    }
  },
  model: {
    prop: "value",
    event: "input"
  },
  data: function data() {
    return {
      visibles: true,
      like1: "",
      like2: "",
      arr: "",
      mea: "",
      paces: "",
      sizename: "",
      checkedTxtt: "",
      listQuery: {
        currentPage: 1,
        pageSize: 20
      },
      total: 0,
      list: [],
      filteredList: [],
      innerValue: "",
      keyword: "",
      keyname: "",
      checked: "",
      checkedTxt: "",
      listLoading: false,
      visible: false,
      refreshDataList: []
    };
  },
  watch: {
    value: function value(val) {
      this.setDefault();
    }
  },
  computed: {
    propsLabel: function propsLabel() {
      return this.columnOptions[0].value;
    }
  },
  created: function created() {
    this.getData();
    // this.initData()
  },
  methods: {
    values: function values(val) {
      // console.log(this.innerValue, "val");
      if (this.innerValue == "") {
        this.checked = this.innerValue;
        this.$emit("input", this.checked);
        this.$emit("change", this.checked);
      }
      // console.log(this.innerValue, "this.innerValue");
      // console.log("values");
      // this.checked = this.innerValue;
      // this.$emit("input", this.checked);
      // this.$emit("change", this.checked);
    },
    getDatalive: function getDatalive() {
      this.innerValue = "";
    },
    getData: function getData() {
      var _this = this;
      if (!this.interfaceId) return;
      this.listLoading = true;
      var _query = _objectSpread({}, this.listQuery);
      var query = {};
      for (var key in _query) {
        if (Array.isArray(_query[key])) {
          query[key] = _query[key].join();
        } else {
          query[key] = _query[key];
        }
      }
      var arrlist = "";
      console.log(this.keyword, "this.keyword");
      if (this.keyword == "") {
        arrlist = "";
        // this.arr = "";
        // this.arrr = "";
        // this.like1 = "";
        // this.acs = "";
        // this.acss = "";
        // this.like2 = "";
      } else {
        arrlist = "AND F_ACCOUNT LIKE'%".concat(this.keyword, "%'OR F_REALNAME LIKE'%").concat(this.keyword, "'");
        // this.arr = "AND F_CODE ";
        // this.like1 = "LIKE";
        // this.arrr = "'%" + this.keyword + "%'";
        // this.acs = "OR F_NAME ";
        // this.acss = "'%" + this.keyword + "%'";
        // this.like2 = "LIKE";
      }
      request({
        url: this.interfaceId + "/" + this.listQuery.currentPage + "/" + this.listQuery.pageSize,
        method: this.strmethod,
        data: {
          // "WhereSql": "AND F_CODE=" + "'" + this.keyword + "'" + "AND ITEM_NAME=" + "'" + this.keyname
          WhereSql: arrlist
          // text:
        }
      }).then(function (res) {
        _this.filteredList = res.data.list;
        _this.listLoading = false;
        _this.total = res.data.pagination.total;
        _this.setDefault();
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    search: function search() {
      this.getData();
    },
    reset: function reset() {
      this.keyword = "";
      this.keyname = "";
      this.filteredList = this.list;
      this.search();
    },
    refresh: function refresh() {
      this.keyword = "";
      this.getData();
    },
    openDialog: function openDialog() {
      if (this.disabled) return;
      // this.keyword = "";
      this.checked = this.value;
      this.keyword = this.innerValue;
      this.visible = true;
      if (!this.list.length) {
        this.getData();
      } else {
        this.filteredList = this.list;
      }

      // this.getData();
    },
    clear: function clear() {
      this.checked = "";
      this.innerValue = "";
      this.$emit("input", this.checked);
      this.$emit("change", this.checked);
      this.$emit("refreshDataList", []);
    },
    select: function select() {
      if (!this.checked) return;
      this.innerValue = this.checkedTxt;
      this.$emit("input", this.checked);
      this.$emit("change", this.checked);
      this.$emit("getName", this.checkedTxtt);
      // this.$emit("refreshDataList", this.refreshDataList);
      this.visible = false;
    },
    rowClick: function rowClick(row) {
      console.log("rowClick");
      // this.refreshDataList = row;
      this.checked = row[this.propsValue];
      this.checkedTxt = row[this.propsLabel];
      this.checkedTxtt = row.CUSTOMERNAME;
      // console.log(row.CUSTOMERNAME)
    },
    setDefault: function setDefault() {
      var _this2 = this;
      console.log(this.value, "value2");
      if (!this.value) {
        this.$emit("refreshDataList", []);
        // return (this.innerValue = "");
      }
      request({
        url: this.interfaceId + "/" + this.listQuery.currentPage + "/" + this.listQuery.pageSize,
        method: this.strmethod,
        data: {
          WhereSql: "AND ID LIKE " + "'" + this.value + "'"
        }
      }).then(function (res) {
        // console.log(res);
        if (res.data.list != "") {
          _this2.innerValue = res.data.list[0].F_REALNAME;
          console.log(_this2.innerValue, "this.innerValue");
          _this2.$emit("refreshDataList", res.data.list[0]);
        }
      });
      // for (let i = 0; i < this.list.length; i++) {
      //   if (this.list[i][this.propsValue] === this.value) {
      //     this.innerValue = this.list[i][this.propsLabel];
      //     this.$emit("refreshDataList", this.list[i]);
      //     break;
      //   }
      // }
    }
  }
};